export enum JsonPathingType {
  JSONATA,
  PATHING,
  JMES,
}
